<div class="version-info-container" [class.collapsed]="isCollapsed()">
	<div class="version-info">
		<div class="app-logo">
			<img src="assets/images/logo/logo.png" alt="DocCycle" class="w-20" />
		</div>

		<div class="version-actions">
			<!-- היסטורית גרסאות
			<button
				class="version-action-btn"
				title="היסטורית גרסאות"
				(click)="changelogClick.emit()"
				*dcDevice="{mobile: false}"
			>
				<i class="fa-regular fa-history"></i>
			</button> -->

			<!-- פרטי גרסה -->
			@if (!isCollapsed()) {
				@let appVersionsString = appInfoStore.appVersionsString$();
				<button
					class="version-action-btn"
					[title]="'גרסה ' + (versionInfo() || '')"
					(click)="versionInfoClick.emit()"
					[pTooltip]="appVersionsString"
					tooltipStyleClass="dc-tooltip dc-gray-tooltip whitespace-pre"
					[tooltipOptions]="{tooltipPosition: 'top', positionTop: -5}"
					[cdkCopyToClipboard]="appVersionsString"
					(cdkCopyToClipboardCopied)="
						toastService.open({
							message: 'dccomp.sidenav.versionInfo.copied',
							type: 'success',
							life: 2500,
							styleClass: 'text-center',
						})
					"
				>
					<icon icon="fa-regular fa-circle-info" />
				</button>
			}
			<!-- התקנת אפליקציה -->
			<button class="version-action-btn" title="התקן אפליקציה" [class.hidden]="isCollapsed()" *dcDevice="{mobile: true, desktop: false}">
				<icon icon="fa-regular fa-download" />
			</button>
		</div>
	</div>
</div>
